// i18n area 'auth' — locale bg-BG (task #171, onda 4): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/auth.bg-BG.meta.json.
import type { enUS } from './auth'

export const bgBG: typeof enUS = {
  login: {
    welcome: 'Trantor TVirt v6',
    subtitle: 'Влезте в акаунта си',
    username: 'Потребителско име',
    usernamePlaceholder: 'Въведете потребителското име',
    usernameHint: 'Използвайте потребител@домейн за вход през директориен реалм',
    continue: 'Продължи',
    changeUser: 'Не сте вие?',
    password: 'Парола',
    forgotPassword: 'Забравена парола?',
    submit: 'Вход',
    otp: 'Еднократен код',
    otpSubtitle: 'Въведете кода от вашия автентикатор',
    otpHint: 'Шест цифри от приложението за автентикация или един от кодовете за възстановяване',
    otpSubmit: 'Провери',
    invalidCredentials: 'Невалидно потребителско име или парола',
    tooManyAttempts: 'Твърде много опити — изчакайте момент и опитайте отново',
    realmUnavailable: 'В момента реалмът не може да провери идентификационните данни — хранилището на конфигурацията е недостъпно. Влезте като локален потребител (break-glass).',
    genericError: 'Неуспешен вход — достъпен ли е бекендът на TVirt?'
  },
  user: {
    logout: 'Изход',
    password: {
      menu: 'Смени паролата',
      title: 'Смяна на паролата',
      current: 'Текуща парола',
      new: 'Нова парола',
      confirm: 'Потвърди новата парола',
      mismatch: 'Паролите не съвпадат',
      error: 'Неуспешна смяна на паролата',
      forcedTitle: 'Сменете паролата, за да продължите',
      forcedHint: 'Тази парола е зададена от администратор и трябва да бъде сменена преди влизане.',
      forcedSubmit: 'Смени и влез'
    },
    mfa: {
      title: 'Двуфакторна автентикация',
      subtitle: 'Втори фактор, изискван при всеки вход',
      loadError: 'Неуспешно зареждане на състоянието на втория фактор',
      enrolled: 'Активен',
      notEnrolled: 'Неактивен',
      enrolledAt: 'Активиран на',
      codesRemaining: 'Оставащи кодове за възстановяване',
      requiredHint:
        'Администратор изисква втори фактор за този акаунт: настройте го сега — докато не го направите, можете да влизате, но почти нищо друго.',
      enroll: 'Настрой',
      enrollTitle: 'Настройка на двуфакторната автентикация',
      enrollHint: 'Сканирайте този код с приложението за автентикация, после въведете кода, който то показва, за да потвърдите.',
      secretHint: 'Не можете да го сканирате? Въведете този секрет в приложението:',
      code: 'Код от приложението',
      confirm: 'Потвърди',
      startError: 'Неуспешно стартиране на настройката',
      confirmError: 'Неуспешно потвърждаване на настройката',
      codesTitle: 'Вашите кодове за възстановяване',
      codesWarning:
        'Тези кодове се показват само веднъж. Запазете ги сега: всеки от тях ви позволява вход, когато автентикаторът не е наличен, и важи само веднъж.',
      codesAck: 'Запазих кодовете за възстановяване',
      codesDone: 'Готово',
      copy: 'Копирай',
      copied: 'Копирано',
      download: 'Изтегли',
      regenerate: 'Нови кодове за възстановяване',
      regenerateTitle: 'Генериране на нови кодове за възстановяване',
      regenerateHint: 'Всички издадени досега кодове спират да работят в момента, в който се генерира новият набор.',
      regenerateConfirm: 'Генерирай наново',
      regenerateError: 'Неуспешно генериране на нови кодове за възстановяване',
      remove: 'Премахни',
      removeTitle: 'Премахване на втория фактор',
      removeConfirm: 'Премахни',
      removeHint: 'Акаунтът се връща само към парола. Можете да настроите втори фактор отново по всяко време.',
      removeRequiredHint:
        'Администратор изисква втори фактор за този акаунт, затова сървърът ще откаже премахването — помолете първо да се вдигне изискването.',
      removeError: 'Неуспешно премахване на втория фактор'
    },
    profile: {
      menu: 'Към моя профил',
      sessions: 'Активни сесии',
      sessionsHint: 'Вашите отворени сесии на този възел',
      sessionsEmpty: 'Няма активни сесии',
      sessionCreated: 'Влизане',
      sessionExpires: 'Изтича',
      revoke: 'Отзови сесията',
      revokeError: 'Неуспешно отзоваване на сесията',
      loadError: 'Неуспешно зареждане на сесиите'
    }
  }
}
